import React, {useContext} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const IngredientUnits = ({responseIndex}) => {

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById] = byId

    return(
        <React.Fragment>
            <p>{
                recipeById.billOfMaterials[responseIndex].hasOwnProperty('stock') ?
                    recipeById.billOfMaterials[responseIndex].stock.unit : <span>-</span>
            }</p>
        </React.Fragment>
    )
}
export default IngredientUnits